import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { searchApi } from '../../api/search';
import { recentSearches } from './recentSearches';
import { useUserStore } from '../../stores/userStore';
import { useWebLocale } from '../../contexts/WebLocaleContext';

// Separate keys and AbortSignals prevent a slower previous search from replacing
// the current result, including when returning through browser history.
export function useSearchResults(query, category = 'summary') {
  const term = (query || '').trim();
  const userId = useUserStore((state) => state.user?.id);
  const { locale } = useWebLocale();
  useEffect(() => {
    if (term) recentSearches.add(term);
  }, [term]);
  return useQuery({
    queryKey: ['web-search-results', userId || 'guest', locale, category, term],
    enabled: Boolean(term),
    retry: false,
    staleTime: 30_000,
    queryFn: async ({ signal }) => {
      const response =
        category === 'summary'
          ? await searchApi.searchSummary(term, {
              signal,
              authenticated: Boolean(userId),
              params: { locale },
            })
          : await searchApi.searchCategory(category === 'mixes' ? 'lists' : category, term, {
              signal,
              authenticated: Boolean(userId),
              params: { locale },
            });
      return response.data;
    },
  });
}
